import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit} from '@angular/core';
import {FormTO} from "../../../../../classes/form-to";
import {ProcessBuilderService} from "../../../../../services/process-builder.service";
import {Subject} from "rxjs";
import {ProcessFlatNode} from "../../../../../classes/process-flat-node";
import {TransformUntilMe} from "../../../../../classes/transform-until-me";
import {Transformation} from "../../../../../classes/transformation";

@Component({
  selector: 'sprout-designer-jolt',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './jolt.component.html',
  styleUrls: ['./jolt.component.css']
})
export class JOLTComponent implements OnInit {

  @Input()
  processNode: ProcessFlatNode;

  editorChangeEvent = new EventEmitter();

  handlebarsEditor: monaco.editor.IStandaloneCodeEditor;

  public form: FormTO;

  public model: any;
  public html: any;
  public modelView: string;

  context = this;
  handlebarsEditorDeclarations: any;

  monacoHtmlOptions:any = {theme: 'vs',
    language: 'html',
    readOnly: false,
    minimap: {
      enabled: false
    },
    printMargin: false,
    readonly: true};

  monacoHandlebarsOptions:any = {theme: 'vs',
    language: 'handlebars',
    readOnly: false,
    glyphMargin: false,
    minimap: {
      enabled: false
    },
    printMargin: false,
    readonly: true};

  monacoJsonOptions:any = {theme: 'vs',
    language: 'json',
    readOnly: true,
    minimap: {
      enabled: false
    },
    printMargin: false,
    readonly: true};
  // options:any = {printMargin: false, theme: 'vs-dark'};
  template: string= '<html>\n' +
      '    <body>\n' +
      '        {{#i18n "greeting"}}Hello{{/i18n}}, {{model.firstName}}!\n' +
      '    </body>\n' +
      '</html>';



  private _formValue = new Subject();
  formValue$ = this._formValue.asObservable();

  constructor(private processBuilderService: ProcessBuilderService, private changeDetectorRef: ChangeDetectorRef) {

    this.form = processBuilderService.form;

    if (this.processNode) {
      processBuilderService.processNode = this.processNode;
    } else {
      this.processNode = processBuilderService.processNode;
    }

  }


  ngOnInit(): void {
  }

  onFormValueChange(formValue: any) {
    console.log('onFormValueChange.formValue:');
    console.dir(formValue);
    console.log('onFormValueChange.processNode:');
    console.dir(this.processNode);

    const transformUntilMe = new TransformUntilMe();
    transformUntilMe.process = this.processNode;
    transformUntilMe.input = formValue;
    transformUntilMe.inputContentType = 'application/json';

    this.processBuilderService.processUntilMe(transformUntilMe).subscribe(response => {
      // console.log('processUntilMe.response:');
      // console.dir(response);

      if (response.outputContentType && response.outputContentType === 'application/json') {
        // console.log('name: ' + response.output['firstName']);

        this.model = response.output;
        this.modelView = JSON.stringify(this.model, null, 3);
        this.changeDetectorRef.detectChanges();

        this.onExecuteTemplate();
      }

    });
  }

  public onExecuteTemplate() {
    console.log('onExecuteTemplate');
    console.dir(this.template);
    console.dir(this.model);

    const transformation: Transformation = new Transformation();
    transformation.processType = this.processNode.processType;
    transformation.template = this.template;
    transformation.input = JSON.stringify(this.model);
    transformation.inputContentType = 'application/json';
    this.processBuilderService.execute(transformation).subscribe(transformation => {
      console.log('execute:');
      console.dir(transformation);

      if (transformation) {
        if (!transformation.errorInd) {
          if (transformation.outputContentType && transformation.outputContentType == 'application/html') {
            this.html = transformation.output;
            this.changeDetectorRef.detectChanges();

            if (this.handlebarsEditor) {
              monaco.editor.setModelMarkers(this.handlebarsEditor.getModel(), 'test', []);
            }

            this.handlebarsEditorDeclarations = undefined;
          }
        } else {
          if (transformation.message) {

            const messageParts: any[] = transformation.message.split(":");
            // console.log('messageParts');
            // console.dir(messageParts);

            if (messageParts && messageParts.length > 3) {
              const line: number = messageParts[1] as number;
              const position: number = messageParts[2] as number;

              if (line && position) {

                console.log('line type: ' );

                // const lineTest = 3;
                // const positionTest = 30;

                // console.log('line: ' + line);
                // console.log('position: ' + position);

                let message = '';

                for (var _i = 3; _i < messageParts.length; _i++) {
                  if (_i > 3) message += "\n";
                  message += messageParts[_i];
                }

                if (this.handlebarsEditor) {
                  monaco.editor.setModelMarkers(this.handlebarsEditor.getModel(), 'test', [{
                    startLineNumber: +line,
                    startColumn: +position + 1,
                    endLineNumber: +line,
                    endColumn: 1000,
                    message: message,
                    severity: monaco.MarkerSeverity.Error
                  }]);
                }
                // monaco.editor.setModelMarkers(this.handlebarsEditor.getModel(), 'test', [{
                //   startLineNumber: line,
                //   startColumn: position,
                //   endLineNumber: line + 1,
                //   endColumn: 1000,
                //   message: message,
                //   severity: monaco.MarkerSeverity.Error
                // }])


              //
              }
            }

            // jolt.component.ts:137 inline@5e935c02:3:29: found: '{{!\n    </body>\n</html>'
            // Hello, {{firstName}} {{!


            // this.handlebarsEditorDeclarations = this.handlebarsEditor.deltaDecorations([], [
            //   {
            //     range: new monaco.Range(3,1,3,1),
            //     options: {
            //       isWholeLine: true,
            //       className: 'myContentClass',
            //       glyphMarginClassName: 'myGlyphMarginClass'
            //     }
            //   }
            // ]);

            console.error(transformation.message);
          }
        }
      }

    });
  }

  onInitHandlebarsEditor(editor: monaco.editor.IStandaloneCodeEditor, parent) {
    if (!editor) {
      return;
    }

    this.handlebarsEditor = editor;

    let timer = -1;
    let runner = function() {
      timer = -1;
      parent.editorChangeEvent.emit();
      parent.onExecuteTemplate()
    }

    editor.onDidChangeModelContent(() => {
      if (timer !== -1) {
        clearTimeout(timer);
      }
      timer = setTimeout(runner, 500);

      // const template = editor.getModel().getValue();
    });
  }
}
